import { useState } from 'react';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardMenu, CardMenuHeader } from '../../cardMenu/components/CardMenu';
import { PlaylistAssignmentsSearchProvider } from './PlaylistAssignmentsSearch';
import { UnAssignPlaylist, UnassignPlaylistHeader } from './UnAssignPlaylist';
import { usePlaylistAssignmentsPortals } from '../playlistAssignmentsQueries';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
const useIsLoadingFirstPlaylistAssignmentsPage = (playlistId, isOpen) => {
  const {
    playlistAssignmentsPortalsLoading
  } = usePlaylistAssignmentsPortals({
    playlistId,
    skip: !isOpen
  });
  return playlistAssignmentsPortalsLoading;
};
export const CardMenuUnassignPlaylistOption = ({
  playlistId,
  onPortalClick,
  onAssignmentClick,
  onUnassigned
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOnOpenChange = e => setIsOpen(e.target.value);
  const handleUnassignClick = () => setIsOpen(true);
  const isLoadingFirstPlaylistAssignmentsPage = useIsLoadingFirstPlaylistAssignmentsPage(playlistId, isOpen);
  const handleOnUnassigned = (portalId, assignmentId) => {
    setIsOpen(false);
    if (onUnassigned) onUnassigned(portalId, assignmentId);
  };
  return /*#__PURE__*/_jsx(PlaylistAssignmentsSearchProvider, {
    children: /*#__PURE__*/_jsx(CardMenu, {
      content: {
        header: /*#__PURE__*/_jsx(CardMenuHeader, {
          children: /*#__PURE__*/_jsx(UnassignPlaylistHeader, {})
        }),
        body: /*#__PURE__*/_jsx(UnAssignPlaylist, {
          onAssignmentClick: onAssignmentClick,
          onPortalClick: onPortalClick,
          onUnassigned: handleOnUnassigned,
          playlistId: playlistId
        })
      },
      onOpenChange: handleOnOpenChange,
      open: isOpen && !isLoadingFirstPlaylistAssignmentsPage,
      placement: "right bottom",
      children: /*#__PURE__*/_jsx(SideNavItem, {
        "data-test-id": "unassign-playlist-button",
        iconRight: isLoadingFirstPlaylistAssignmentsPage ? /*#__PURE__*/_jsx(LoadingSpinner, {
          insetInlineEnd: "200",
          size: "extra-small"
        }) : /*#__PURE__*/_jsx(IconHolder, {
          color: "icon-interactive-default",
          icon: RightIcon,
          paddingInline: "0",
          size: "100"
        }),
        onClick: handleUnassignClick,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlistAssignments.unassignPlaylist"
        })
      })
    })
  });
};
export default CardMenuUnassignPlaylistOption;